import { LANGS, setLang, useLang } from '../i18n';

type Props = {
  compact?: boolean;
};

export function LangSwitcher({ compact }: Props) {
  const lang = useLang();
  return (
    <div className={`lang-switcher${compact ? ' compact' : ''}`}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={l.code === lang ? 'active' : ''}
          aria-label={l.label}
        >
          {compact ? l.code.toUpperCase() : l.label}
        </button>
      ))}
    </div>
  );
}
